import { useMemo } from "react";
import "./CodeRain.css";

const caracteres = "ABCDVWXYZ0123456789<>/{}[]@$#!%¨&*";

function gerarCaracteres() {
    return Array.from(
        { length: Math.floor(Math.random() * (10 - 5 + 1)) + 5 },
        () => {
            return caracteres[
                Math.floor(Math.random() * caracteres.length)
            ];
        }
    );
}

export default function CodeRain() {

    const cores = [
        "#ffb22e75",
        "#3f5d7a82",
        "#172c548f",
        "#aebbc695"
    ];

    const fontSize = [
        14,
        8,
        4
    ];

    const colunas = useMemo(() => {
        return Array.from({ length: 20 }, (_, index) => ({
            id: index,
            caracteres: gerarCaracteres(),
            duracao: 3 + Math.random() * 10,
            delay: Math.random() * 5,
            cor: cores[Math.floor(Math.random() * cores.length)],
            fontSize: fontSize[Math.floor(Math.random() * fontSize.length)]
        }));
    }, []);

    return (
        <div className="codeRain">
            {colunas.map((coluna) => (
                <div
                    className="codeColumn"
                    key={coluna.id}
                    style={{
                        animationDuration: `${coluna.duracao}s`,
                        animationDelay: `${coluna.delay}s`,
                        color: coluna.cor,
                    }}
                >
                    {coluna.caracteres.map((char, index) => {
                        const progresso =
                            index / (coluna.caracteres.length - 1);

                        return (
                            <span
                                key={index}
                                style={{
                                    fontSize: `${coluna.fontSize + progresso * 7}px`,
                                    opacity: 0.2 + progresso * 0.85,
                                    textShadow:
                                        index === coluna.caracteres.length - 1
                                            ? "0 0 5px currentColor, 0 0 10px currentColor, 0 0 20px currentColor"
                                            : "none"
                                }}
                            >
                                {char}
                            </span>
                        );
                    })}
                </div>
            ))}
        </div>
    );
}